(function() { window.GUID_55fdda8d_4eb8_4189_93fb_8a5319de6678 = { getGuid: function() { return "55fdda8d-4eb8-4189-93fb-8a5319de6678"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class FollowUnfollowButton extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                try {
                    this.controlId = params[0];
                    this.personaId = params[1];
                }
                catch (error) {
                    console.error("Error instantiating control.", error);
                }
            }
            OnBindEvents() {
                try {
                    this.$Control.offon(`click.${this.constructor.name}-clicked`, "button", this.handleClick.bind(this));
                }
                catch (error) {
                    console.error("Error binding events.", error);
                }
            }
            OnDispose() { }
            OnControlRendered() { }
            handleClick(e) {
                try {
                    const $button = $(e.currentTarget);
                    const buttonData = $button.data("html");
                    const action = buttonData.action;
                    if (action === "openNotificationsModal") {
                        const $notificationsButton = this.$Control.find(".cs-notifications-button");
                        if (!$notificationsButton.length) {
                            return;
                        }
                        $notificationsButton.click();
                    }
                    else {
                        const wasFollowing = action === "unfollow";
                        const url = CS.Url.CSUrl("FriendUpdateFollow");
                        const data = {
                            friendPersonaId: this.personaId,
                            wasFriend: wasFollowing,
                            returnJson: true,
                        };
                        CS.Ajax.Post(url, data, (response) => {
                            if (response.success) {
                                let me = this;
                                me.$Control.hide();
                                me.Trigger(FollowUnfollowButton.EventNames.FollowingStateChanged, {
                                    jqueryEventObject: e,
                                    data: {
                                        personaId: me.personaId,
                                        isNowFollowing: !wasFollowing,
                                    },
                                });
                                CS.DOM.$body.trigger(`FollowUnfollowButton.${FollowUnfollowButton.EventNames.FollowingStateChanged}`, {
                                    personaId: me.personaId,
                                    isNowFollowing: !wasFollowing,
                                });
                            }
                        });
                    }
                }
                catch (error) {
                    console.error("Error handling click.", error);
                }
            }
        }
        Controls.FollowUnfollowButton = FollowUnfollowButton;
        (function (FollowUnfollowButton) {
            class Events {
                static FollowingStateChanged(param) {
                    Controls.RegisterEvent(FollowUnfollowButton, EventNames.FollowingStateChanged, param);
                }
            }
            FollowUnfollowButton.Events = Events;
            class EventNames {
            }
            EventNames.FollowingStateChanged = "FollowingStateChanged";
            FollowUnfollowButton.EventNames = EventNames;
        })(FollowUnfollowButton = Controls.FollowUnfollowButton || (Controls.FollowUnfollowButton = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=FollowUnfollowButton.js.map
